import { supabase } from "@/integrations/supabase/client";

interface NotifyPayload {
  source: "kontakt" | "angebot";
  name: string;
  email: string;
  phone?: string | null;
  message: string;
}

export async function notifyWhatsApp(payload: NotifyPayload): Promise<void> {
  try {
    await supabase.functions.invoke("notify-inquiry", {
      body: payload,
    });
  } catch {
    // Silently fail — the DB submission already succeeded
    if (import.meta.env.DEV) {
      console.error("WhatsApp notification failed");
    }
  }
}
